mutation CreateNewsItem($newsItemChanges: NewsItemChangeInput!) {
  createNewsItem(input: { newsItemChanges: $newsItemChanges }) {
    newsItem {
      id
    }
  }
}
